import { createContext, type ReactNode, use } from "react";
import type { LocationOption } from "./LocationPicker";

export type LocationSuggestion = {
    placeId: string;
    label: string;
};

export type LocationSearch = {
    searchLocation: (query: string) => Promise<LocationSuggestion[]>;
    resolveLocation: (placeId: string) => Promise<LocationOption | null>;
};

const LocationSearchContext = createContext<LocationSearch | null>(null);

export function LocationSearchProvider({
    value,
    children,
}: {
    value: LocationSearch;
    children: ReactNode;
}) {
    return <LocationSearchContext value={value}>{children}</LocationSearchContext>;
}

export function useLocationSearch(): LocationSearch {
    const value = use(LocationSearchContext);
    if (!value) {
        throw new Error("useLocationSearch requires a LocationSearchProvider");
    }
    return value;
}
